import hr from '@src/service/i18n/message/hr';
import sl from '@src/service/i18n/message/sl';

export const MESSAGES = {
  hr,
  sl,
} as any;
